let state = {
  totalPaymentsAvailable: undefined,
  totalPaymentsFetched: undefined,
  payments: []

}
export default state



// WEBPACK FOOTER //
// ./src/store/payments/state.js